import { render } from "./Radio.vue?vue&type=template&id=54630f46"
import script from "./Radio.vue?vue&type=script&lang=ts"
export * from "./Radio.vue?vue&type=script&lang=ts"
script.render = render

export default script